// Generated by CoffeeScript 2.7.0
var SPEACIAL_FIELDS, SettingsRedPacketQuotas;

SPEACIAL_FIELDS = [
  {
    id: -1,
    title: '姓名',
    type: 'Field::UserItem',
    _hidden: false
  },
  {
    id: -2,
    title: '识别码',
    type: 'Field::TextField',
    _hidden: false
  },
  {
    id: -3,
    title: '手机号',
    type: 'Field::TextField',
    _hidden: false
  },
  {
    id: -4,
    title: '剩余额度/总额度',
    type: 'Field::TextField',
    _hidden: false
  }
];

import RedPacketQuotasTable from 'trunks/vue/admin/components/settings/settings_red_packet_quotas/red_packet_quotas_table.js';

import AddRedPacketQuotasModal from 'trunks/vue/admin/components/settings/settings_red_packet_quotas/add_red_packet_quotas_modal.js';

export default SettingsRedPacketQuotas = Vue.extend({
  components: {
    'red-packet-quotas-table': RedPacketQuotasTable
  },
  data: function() {
    return {
      resourceUrl: '/admin/settings/red_packet_quotas.json',
      datableGID: new Skylark.Libs.GlobalID("gid://skylark/Red_packet_quotas/-1"),
      fieldable: {
        fields: []
      }
    };
  },
  template: `<div class="settings-red-packet-quotas-container">
  <div class="main-content-top">
    <button class="adding-btn" @click="openAddModal">新增</button>
  </div>
  <div class="datable-table">
    <red-packet-quotas-table :resourceUrl="resourceUrl"
                             :speacialFields="speacialFields"
                             :fieldable="fieldable"
                             :datableGID="datableGID"
                             ref="redPacketQuotasTableRef" />
  </div>
</div>`,
  computed: {
    speacialFields: function() {
      return SPEACIAL_FIELDS;
    }
  },
  methods: {
    openAddModal: function() {
      return new AddRedPacketQuotasModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-red_packet_quotas-modal-container'),
        propsData: {
          callback: () => {
            return this.$refs.redPacketQuotasTableRef.refreshData();
          }
        }
      });
    }
  }
});
